import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { mediaOriginalReducer } from './media.reducer';
import { MediaOriginalSliceState, MediaSliceKey } from './media.state';

export const MediaFeatureKey = 'Media';

export interface MediaFeatureState {
	[MediaSliceKey]: MediaOriginalSliceState;
}

export interface MediaRootState extends IAppRootState {
	[MediaFeatureKey]: MediaFeatureState;
}

export const featureSelector =
	createFeatureSelector<MediaFeatureState>(MediaFeatureKey);

export const mediaReducers: ActionReducerMap<MediaFeatureState> = {
	[MediaSliceKey]: mediaOriginalReducer,
};
